export default __webpack_public_path__ + "69a64dee49d61afe003dee5c95120ea0.svg";